var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        { staticClass: "profile-row", attrs: { gutter: 50 } },
        [
          _c("el-col", { attrs: { span: 8 } }, [
            _c("div", { staticClass: "profile-label" }, [
              _vm._v("\n        Timezone\n      "),
            ]),
          ]),
          _vm._v(" "),
          _c("el-col", { attrs: { span: 16 } }, [_c("TimeZoneSelector")], 1),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        { staticClass: "profile-row", attrs: { gutter: 50 } },
        [
          _c("el-col", { attrs: { span: 8 } }, [
            _c("div", { staticClass: "profile-label" }, [
              _vm._v("\n        Language\n      "),
            ]),
          ]),
          _vm._v(" "),
          _c("el-col", { attrs: { span: 16 } }, [_c("LanguageSelector")], 1),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }